import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation } from '@/modules/common';

interface CreateCategoryPayload {
  name: string;
}

export function useCreateCategory() {
  const queryClient = useQueryClient();

  const createCategoryMutation = useApiMutation<CreateCategoryPayload>(
    '/system-prompts/categories',
    { method: 'POST' },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['/system-prompts/categories'],
        });
      },
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return { createCategoryMutation } as const;
}
